import React, { useState } from 'react'
import { usePlacesWidget } from 'react-google-autocomplete'
import styles from './Search.module.scss'
import { PositionType } from '../../../type/PositionType'

const centerLat = Number(window.env.REACT_APP_GEOGRAPHICAL_CENTER_LAT)
const centerLng = Number(window.env.REACT_APP_GEOGRAPHICAL_CENTER_LNG)
const centerRadius = Number(window.env.REACT_APP_GEOGRAPHICAL_CENTER_RADIUS)

interface SearchProps {
    setPosition: (position: PositionType) => void
}

export const Search = ({ setPosition }: SearchProps) => {
    const [val, setVal] = useState('')

    // Only proceed if google maps is loaded
    const isLoaded = typeof google !== 'undefined' && google.maps

    const { ref } = usePlacesWidget({
        apiKey: window.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        onPlaceSelected: (place) => {
            if (place && place.geometry && place.geometry.location) {
                const location = place.geometry.location
                const lat =
                    typeof location.lat === 'function'
                        ? (location.lat() as number)
                        : (location.lat as any as number)
                const lng =
                    typeof location.lng === 'function'
                        ? (location.lng() as number)
                        : (location.lng as any as number)
                setPosition({ lat, lng })
            }
            if (place && place.formatted_address) {
                setVal(place.formatted_address)
            }
        },
        options: {
            types: ['geocode'],
            componentRestrictions: { country: 'CZ' },
            // create a bounding box with sides "radius" away from the center point
            bounds: isLoaded
                ? {
                      north: centerLat + centerRadius,
                      south: centerLat - centerRadius,
                      east: centerLng + centerRadius,
                      west: centerLng - centerRadius,
                  }
                : undefined,
            strictBounds: true,
        },
        language: 'cs',
    })

    if (!isLoaded) return null

    return (
        <div className={styles.wrapper}>
            <img className={styles.search} src="/img/icon/search.svg" alt="" />
            <input
                className={styles.input}
                onChange={(e) => {
                    setVal(e.target.value)
                }}
                value={val}
                type="text"
                // @ts-ignore
                ref={ref}
                placeholder={'Zadejte polohu'}
            />
            {val.length > 0 && (
                <img
                    className={styles.closer}
                    src="/img/icon/closer.svg"
                    alt=""
                    onClick={() => setVal('')}
                />
            )}
        </div>
    )
}
